var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0A8.5,8.5,0,1,0,17,8.5,8.5,8.5,0,0,0,8.5,0Zm.907,13.464a1.182,1.182,0,0,1-.886.371,1.268,1.268,0,0,1-1.264-1.264,1.182,1.182,0,0,1,.371-.886,1.229,1.229,0,0,1,.893-.364,1.244,1.244,0,0,1,1.25,1.25A1.218,1.218,0,0,1,9.407,13.464Zm1.886-6.2a5.51,5.51,0,0,1-.943,1.129,3.525,3.525,0,0,0-.679.8,1.735,1.735,0,0,0-.179.843v.229H7.579V9.786a2.347,2.347,0,0,1,.3-1.207A5.253,5.253,0,0,1,8.914,7.414a3.665,3.665,0,0,0,.629-.679,1.181,1.181,0,0,0,.2-.671A1.013,1.013,0,0,0,9.407,5.3a1.242,1.242,0,0,0-.886-.314,1.338,1.338,0,0,0-.95.343,1.872,1.872,0,0,0-.529.85l-1.671-.7a3.254,3.254,0,0,1,1.079-1.6A3.046,3.046,0,0,1,8.471,3.2a3.548,3.548,0,0,1,1.629.364,2.768,2.768,0,0,1,1.107.993,2.579,2.579,0,0,1,.4,1.4A2.43,2.43,0,0,1,11.293,7.264Z",
    fill: "var(--mainColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.53cadb9da835372372293d4c7ee81734.svg";
export { ForwardRef as ReactComponent };